import { action, payload } from 'ts-action'
import { IScreeningDocument } from '../../models/ScreeningDocument'
import { IError, IPayload } from '../../models/Global'

export const ScreeningDocumentsFetching = action('ScreeningDocumentsFetching', payload<boolean>())

export const GetScreeningDocuments = action(
  'GetScreeningDocuments',
  payload<IPayload<IScreeningDocument[]>>()
)

export const UpdateScreeningDocument = action(
  'UpdateScreeningDocument',
  payload<IPayload<IScreeningDocument>>()
)

export const GetScreeningDocumentsErrors = action('GetScreeningDocumentsErrors', payload<IError>())
